import script from "./EmailSend.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailSend.vue?vue&type=script&setup=true&lang=js"

import "./EmailSend.vue?vue&type=style&index=0&id=64ed3074&scoped=true&lang=css"

import exportComponent from "/home/chanli/桌面/data_dashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64ed3074"]])

export default __exports__